import { DataGridFeatureConfig } from '@waseel-asp/tpa-waseel-lib-staging';
import { defaultGridFeatures } from "../../../../../shared/constants/grid-feature-config";
import cloneDeep from 'lodash/cloneDeep';
import { PaymentClaimDetails, PaymentDetails } from "../view-reconciliation-transaction/models/reconciliationTransaction.model";
import { GRID_PAGE_DEFAULT_SIZE } from "../../../../../shared/constants/grid-constant";

export interface ReconciliationList {
    paymentReconciliationId: string
    referenceNo: string;
    totalNet: string;
    finalAmount: string;
    startDate: string;
    endDate: string;
    providerId: string;
    payerId: string;
    providerNameEnglish: string;
    providerNameArabic: string;
    payerNameEnglish: string;
    payerNameArabic: string;
    statusId: string;
    statusNameEnglish: string;
    statusNameArabic: string;
    isRead: boolean
};

export enum Reconciliation {
    Initial = 0,
    OfflineNegotiation = 1,
    Settled = 2,
};

export const ReconciliationLabel: { [key in Reconciliation]: string } = {
    [Reconciliation.Initial]: 'PAYMENT_RECONCILIATION.STATUS.INITIAL_RECONCILIATION',
    [Reconciliation.OfflineNegotiation]: 'PAYMENT_RECONCILIATION.STATUS.UNDER_OFFLINE_NEGOTIATION',
    [Reconciliation.Settled]: 'PAYMENT_RECONCILIATION.STATUS.SETTLED'
};

export const ReconciliationValue: { [key in Reconciliation]: string } = {
    [Reconciliation.Initial]: 'e1c2daa8-48e1-42e8-a5dc-45c276f8f712',//Replace With Guid
    [Reconciliation.Settled]: "406f1388-01ff-45c4-8be1-7ecc830b5fcd",
    [Reconciliation.OfflineNegotiation]: "d79993e4-6ecb-4f9f-a8ea-a1c89a224e77"
};

export const reconciliationDetailsMap = {
    [Reconciliation.Initial]: {
        title: 'PAYMENT_RECONCILIATION.STATUS.INITIAL_RECONCILIATION',
        color: '#3c3b44',
        backgroundColor: '#dfdee6',
        id: ReconciliationValue[Reconciliation.Initial]
    },
    [Reconciliation.OfflineNegotiation]: {
        title: 'PAYMENT_RECONCILIATION.STATUS.UNDER_OFFLINE_NEGOTIATION',
        color: '#d03131',
        backgroundColor: '#f2c4c4',
        id: ReconciliationValue[Reconciliation.OfflineNegotiation]
    },
    [Reconciliation.Settled]: {
        title: 'PAYMENT_RECONCILIATION.STATUS.SETTLED',
        color: '#36793d',
        backgroundColor: '#d7e9d8',
        id: ReconciliationValue[Reconciliation.Settled]
    }
};

export const paymentReconciliationconfig = {
    entityName: 'PAYMENT_RECONCILIATION.TITLE',
    totalNet: "CONVERT_PREAUTH_TO_CLAIM.PREPARE_FOR_CLAIMS.TOTAL_NET",
    status: 'PREAUTH.PREAUTH_TRANSACTION.STATUS',
    referenceNo: 'PAYMENT_RECONCILIATION.RECONCILIATION_TRANSACTION.REF_NO',
    paymentRefNo: 'PAYMENT.LIST.REFERENCE_NUMBER',
    finalAmount: 'PAYMENT.LIST.FINAL_APPROVED_AMOUNT',
    lossMonth: 'PAYMENT.LIST.MULTIPLE_LOSS_MONTH',
    identifier: 'PAYMENT.LIST.PAYMENT_IDENTIFIER',
    group: "PAYMENT.LIST.GROUP_NAME",
    date: "PAYMENT.LIST.PAYMENT_DATE",
    amount: "PAYMENT.LIST.AMOUNT",
    title: "PAYMENT.LIST.TRANSACTION_TITLE",
    provider: "PROVIDER.TITLE",
    payer: "COMMON.PAYER",
    reconciliationStatus: "FORM_FIELD.RECONCILIATION_STATUS"
};

const gridFeatures: DataGridFeatureConfig<PaymentDetails | PaymentClaimDetails> = cloneDeep(defaultGridFeatures);

export const primaryGridFeatures: DataGridFeatureConfig<PaymentDetails> = {
    ...gridFeatures,
    allowSearching: false,
    isPersistanceStorage: false
};

export const childGridReconciliation: DataGridFeatureConfig<PaymentClaimDetails> = {
    ...gridFeatures,
    showPagination: false,
    enableApiSorting: false,
    enableApiSearching: false,
    allowSorting: false,
    isDummyColumn: true,
    allowHideShowColumns: false,
    hideTableHeader: false,
    isDefaultEditEnabled: true,
    isPersistanceStorage: false,
    setTimeout: true
};

export const recentGridFeatures: DataGridFeatureConfig<ReconciliationList> = {
    isRowHoverEnable: true,
    showPagination: true,
    enableApiSearching: false,
    enableApiSorting: true,
    allowSearching: false,
    allowSorting: true,
    allowHideShowColumns: false,
    allowExpandRow: false,
    showCheckboxSelection: false,
    stickyFeature: {
        isStickyHeader: true
    },
    paginatorFeatures: {
        defaultPagesize: GRID_PAGE_DEFAULT_SIZE,
        totalCount: 0,
        currentPageIndex: 0,
        enableApiPagination: true
    }
};